import moment from "moment";
import {debounce} from "lodash";

export default {
    data() {
        return {
            filters: {
                trajectory_manager: null,
                deadline: null
            },
            category_id: null,
            relation_id: null,
            log_form_key: 0
        }
    },

    computed: {
        logsFormApiUrl() {
            return route('logs.store', {
                category: this.category_id,
            })
        },
    },

    methods: {
        sendLogToRelation(relation) {
            this.log_form_key += 1
            this.relation_id = relation.id
            setTimeout(() => {
                this.$refs.relationLogsModal.show()
            }, 500)

        },

        openLogToRelation(trajectoryEnrolment) {
            let routeData = this.$router.resolve({
                name: 'admin.relations.view', params: {
                    'id': trajectoryEnrolment.relation_id
                }
            });
            window.open(routeData.href, '_blank');
        },

        handleLogCreated() {
            this.$refs.relationLogsModal.hide();
            this.forceRefresh = true
        },

        handleCategoryChanged(category_id) {
            this.category_id = category_id
        },

        stopRefreshing() {
            this.forceRefresh = false
        },

        filterDocumentsOnDeadline(documents, value) {
            if (!value || value.length === 0) {
                return documents
            }

            let additionalOperator = ['>', '<'].includes(value.charAt(0))
            let valueToTestOn = additionalOperator ? moment(value.substr(1), 'DD-MM-YYYY') : moment(value, 'DD-MM-YYYY')
            let filteredDocuments = []

            if (valueToTestOn.isValid()) {
                filteredDocuments = documents.filter((document) => {
                        let dueDate = moment(document.action_progress.due_date, 'YYYY-MM-DD')
                        if (additionalOperator) {
                            if (value.charAt(0) === '>') {
                                return dueDate.diff(valueToTestOn) >= 0
                            } else {
                                return dueDate.diff(valueToTestOn) <= 0
                            }
                        }

                        return dueDate.diff(valueToTestOn) === 0
                    }
                )
            }

            return filteredDocuments
        }
    }
}
